import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ParagraphS } from 'components/core/Typography/Typography';
import { mq } from 'styles/mixins';
import { THEME } from '../../../../common/consts/theme';

export const PersonImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 22.5rem;
  max-width: 16.875rem;
  border-radius: 1rem;
  object-fit: cover;
  margin: 0 auto;

  img {
    max-height: 22.5rem;
    max-width: 16.875rem;
    width: 100%;
    height: 100%;
    border-radius: 1rem;
  }

  ${mq.medium(css`
    margin: 0;
  `)};
`;

export const PersonWrapper = styled.li`
  display: flex;
  flex-direction: column;
  row-gap: 1.875rem;
  margin-bottom: 2.5rem;

  ${mq.large(css`
    flex-direction: row;
    column-gap: 1.875rem;
  `)};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const PersonContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PersonSocialLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq.medium(css`
    align-items: flex-start;
  `)};
`;

export const PersonName = styled.p`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
  margin: 0;
  color: ${({ theme }) => theme.colors.core_black};
  text-align: center;

  ${mq.medium(css`
    font-size: 2rem;
    line-height: 2.5rem;
    text-align: left;
    margin-bottom: 0.5rem;
  `)};
`;

export const PersonPosition = styled.p`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 1rem;
  font-weight: 400;
  line-height: 2rem;
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.colors.core_black};
  text-align: center;

  ${mq.medium(css`
    text-align: left;
    margin-bottom: 1.5rem;
  `)};
`;

export const PersonBio = styled.p`
  ${ParagraphS};
  letter-spacing: 0.0125rem;
  margin: 0 0 1rem 0;
  max-width: 35.625rem;
  text-align: center;

  ${mq.medium(css`
    text-align: left;
    margin-bottom: 1.5rem;
  `)};
`;

export const PersonSocialLink = styled.a`
  display: flex;
  flex-direction: row;
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 1rem;
  font-weight: 400;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  gap: 1rem;
  align-items: center;
  text-decoration: underline;

  ${mq.medium(css`
    text-decoration: none;
    color: ${THEME.colors.core_black};
  `)};
`;
